import { nanoid } from '@reduxjs/toolkit';

const id = nanoid();

export default function ArrowUpRight({ color = '#000000', ...props }: Record<string, unknown> & { color?: string }) {
  return (
    <svg
      width="24px"
      height="24px"
      viewBox="0 0 24 24"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      {...props}
    >
      <title>arrow-up-right</title>
      <defs>
        <path
          d="M13,0 C13.0064615,0 13.0129086,6.12825798e-05 13.0193409,0.000183298222 C13.042681,0.000634893312 13.0659949,0.00189498016 13.0892501,0.00396640833 C13.1096949,0.0057479633 13.1294204,0.00810097727 13.1489612,0.0110193427 C13.165949,0.0136280806 13.1833753,0.0167021706 13.2007258,0.020240071 C13.2227461,0.0246397952 13.2444365,0.0298336259 13.2658396,0.0357209664 C13.2814633,0.0400977346 13.2968513,0.0447287157 13.3121425,0.0497380859 C13.3317977,0.0561224864 13.3515792,0.0633157362 13.3710585,0.0711039637 C13.3887956,0.0781964242 13.4060985,0.0856790475 13.4232215,0.0936733617 C13.4438914,0.103376643 13.4642939,0.11379392 13.484277,0.12487577 C13.4963944,0.131498828 13.5086131,0.138606922 13.5207088,0.145995454 C13.546275,0.1617187 13.5711307,0.178490093 13.5951593,0.196313506 C13.6343256,0.225312953 13.6717127,0.257499166 13.7071068,0.292893219 L13.6167501,0.212785965 C13.6801818,0.262551711 13.7374483,0.319818245 13.787214,0.383249919 C13.7927155,0.390157595 13.7982466,0.397396959 13.8036654,0.404693385 C13.8215099,0.428869307 13.8382813,0.453725048 13.8539326,0.479339815 C13.8613931,0.491386894 13.8685012,0.503605559 13.8753288,0.515937903 C13.8862061,0.535706055 13.8966234,0.556108604 13.9063462,0.576900852 C13.914321,0.593901505 13.9218036,0.611204351 13.9287745,0.628663976 C13.9366843,0.648420797 13.9438775,0.668202324 13.9504533,0.688263589 C13.9552713,0.703148659 13.9599023,0.718536724 13.9641549,0.734007034 C13.9701664,0.755563524 13.9753602,0.777253921 13.9798348,0.799205901 C13.9832978,0.816624737 13.9863719,0.83405099 13.9889822,0.851533135 C13.9962388,0.899637905 14,0.949379716 14,1 L13.9962979,0.913769205 C13.9978436,0.931734513 13.9989053,0.949733631 13.9994829,0.967745384 L14,1 L14,10 C14,10.5522847 13.5522847,11 13,11 C12.4477153,11 12,10.5522847 12,10 L12,3.414 L1.70710678,13.7071068 C1.34662282,14.0675907 0.779391764,14.0953203 0.387100557,13.7902954 L0.292893219,13.7071068 C-0.0976310729,13.3165825 -0.0976310729,12.6834175 0.292893219,12.2928932 L10.584,2 L4,2 C3.48716416,2 3.06449284,1.61395981 3.00672773,1.11662113 L3,1 C3,0.44771525 3.44771525,0 4,0 Z"
          id={id}
        />
      </defs>
      <g id="🕹-Icons" stroke="none" strokeWidth={1} fill="none" fillRule="evenodd">
        <g id="Feather" transform="translate(-849, -602)">
          <g id="arrow-up-right" transform="translate(854, 607)">
            <mask id={`mask-${id}`} fill="white">
              <use xlinkHref={`#${id}`} />
            </mask>
            <use id="Combined-Shape" fill={color} fillRule="nonzero" xlinkHref={`#${id}`} />
            <g id="COLOR/-black" mask={`url(#mask-${id})`} fill={color}>
              <g transform="translate(-5, -5)" id="Rectangle">
                <rect x={0} y={0} width={24} height={24} />
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
}
